<template>
  <div class="ui container">
    <div class="ui left aligned container">
      <div class="ui breadcrumb">
        <router-link class="section" to="/mm/stars">明星</router-link>
        <i class="right chevron icon divider"></i>
        <div class="active section">{{ star.name }}</div>
      </div>
    </div>
    <div class="ui divider"></div>

    <div class="ui raised segment">
      <h3>{{ star.id }}: {{ star.name }}</h3>
      <img class="ui avatar image" :src="star.head_img">
      <div>喵币排名： {{ star.mm_sort }}</div>
      <div>粉丝守护： {{ star.guard_num }}</div>
      <div>粉丝安利： {{ star.anli_num }}</div>
    </div>

    <div class="ui buttons">
      <button class="ui button" @click="date=0;load()" :class="{active: date===0}">上周</button>
      <button class="ui button" @click="date=1;load()" :class="{active: date===1}">本周</button>
      <button class="ui button" @click="date=2;load()" :class="{active: date===2}">上月</button>
      <button class="ui button" @click="date=3;load()" :class="{active: date===3}">本月</button>
    </div>

    <table class="ui celled table">
      <thead>
      <tr>
        <th>排名</th>
        <th>投币</th>
        <th>头像</th>
        <th>名字</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="fan in fans">
        <td>{{ fan.sort }}</td>
        <td>{{ fan.mb_num }}</td>
        <td>
          <router-link :to="'/mm/fans/'+fan.openid">
            <img class="ui tiny image" :src="fan.head_img">
          </router-link>
        </td>
        <td>
          <router-link :to="'/mm/fans/'+fan.openid">{{ fan.name }}</router-link>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StarInfo',
  data () {
    return {
      id: '',
      date: 1,
      star: {},
      fans: []
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.loadStar()
    this.load()
  },
  methods: {
    loadStar () {
      axios.get('/mm/stars/' + this.id).then(({ data }) => {
        this.star = data.data
      })
    },
    load () {
      this.fans = []
      axios.get('/mm/stars/' + this.id + '/fans?date=' + this.date).then(({ data }) => {
        this.fans = data.data
      })
    }
  }
}
</script>

<style scoped>

</style>
